import { render, staticRenderFns } from "./MinibusManuelReservation.vue?vue&type=template&id=2a9a6e73&scoped=true&"
import script from "./MinibusManuelReservation.vue?vue&type=script&lang=js&"
export * from "./MinibusManuelReservation.vue?vue&type=script&lang=js&"
import style0 from "./MinibusManuelReservation.vue?vue&type=style&index=0&id=2a9a6e73&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9a6e73",
  null
  
)

export default component.exports